const SidebarData = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  {
    label: "Dashboard",
    icon: "mdi mdi-home-variant-outline",
    url: "/dashboard",
    isHasArrow: true,
    bgcolor: "bg-primary",
  },
  {
    label: "Distributor Management",
    icon: "mdi mdi-account-outline",
    isHasArrow: true,
    url: "/distributor",
  },
  {
    label: "Admin Management",
    icon: "mdi mdi-account-edit-outline",
    isHasArrow: true,
    url: "/admin",
  },
];
export default SidebarData;
